if (!customElements.get('product-grid-atc-card')) {
  customElements.define(
    'product-grid-atc-card',
    class ProductGridAtcCard extends HTMLElement {
      connectedCallback() {
        const variantsScript = this.querySelector('[data-variants-json]');
        if (!variantsScript) return;

        this.variants = JSON.parse(variantsScript.textContent);
        this.variantInput = this.querySelector('[data-variant-input]');
        this.priceEl = this.querySelector('[data-product-price]');
        this.imageEl = this.querySelector('[data-variant-image]');
        this.addToCartBtn = this.querySelector('[data-add-to-cart]');
        this.addToCartText = this.querySelector('[data-add-to-cart-text]');
        this.optionFieldsets = this.querySelectorAll('.product-grid-atc__option');

        this.addEventListener('change', this.onOptionChange.bind(this));
        this.syncSelectedLabels();
        this.updateOptionAvailability();
      }

      onOptionChange(event) {
        if (event.target.type !== 'radio') return;

        this.syncSelectedLabels();
        this.updateOptionAvailability();
        const variant = this.getSelectedVariant();
        this.updateCard(variant);
      }

      getSelectedOptions() {
        const options = [];
        this.optionFieldsets.forEach((fieldset) => {
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          options.push(checked ? checked.value : null);
        });
        return options;
      }

      getSelectedVariant() {
        const selectedOptions = this.getSelectedOptions();
        return (
          this.variants.find((variant) =>
            variant.options.every((option, index) => option === selectedOptions[index])
          ) || null
        );
      }

      syncSelectedLabels() {
        this.optionFieldsets.forEach((fieldset) => {
          fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
            const label = input.nextElementSibling;
            if (label?.classList.contains('swatch-input__label')) {
              label.classList.toggle('swatch-input__label--selected', input.checked);
            }
          });
        });
      }

      updateOptionAvailability() {
        const selectedOptions = this.getSelectedOptions();

        this.optionFieldsets.forEach((fieldset, optionIndex) => {
          fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
            const hasAvailableVariant = this.variants.some((variant) => {
              if (variant.options[optionIndex] !== input.value) return false;

              return variant.options.every((option, index) => {
                if (index === optionIndex) return true;
                if (selectedOptions[index] === null) return true;
                return option === selectedOptions[index];
              });
            });

            const isAvailable = this.variants.some((variant) => {
              if (!variant.available) return false;
              if (variant.options[optionIndex] !== input.value) return false;

              return variant.options.every((option, index) => {
                if (index === optionIndex) return true;
                if (selectedOptions[index] === null) return true;
                return option === selectedOptions[index];
              });
            });

            const isDisabled = !hasAvailableVariant || !isAvailable;
            input.classList.toggle('disabled', isDisabled);
            input.classList.toggle('visually-disabled', isDisabled);
          });
        });
      }

      updateCard(variant) {
        if (!variant) {
          this.setUnavailable();
          return;
        }

        if (this.variantInput) {
          this.variantInput.value = variant.id;
          this.variantInput.disabled = !variant.available;
        }

        if (this.priceEl) {
          this.priceEl.innerHTML = this.buildPriceHtml(variant);
        }

        if (!this.dataset.customImage && this.imageEl && variant.featured_media) {
          this.imageEl.src = variant.featured_media;
          this.imageEl.removeAttribute('srcset');
          this.imageEl.removeAttribute('sizes');
        }

        if (this.addToCartBtn && this.addToCartText) {
          if (variant.available) {
            this.addToCartBtn.disabled = false;
            this.addToCartText.textContent = window.variantStrings?.addToCart || 'Add to cart';
          } else {
            this.addToCartBtn.disabled = true;
            this.addToCartText.textContent = window.variantStrings?.soldOut || 'Sold out';
          }
        }
      }

      setUnavailable() {
        if (this.variantInput) {
          this.variantInput.value = '';
          this.variantInput.disabled = true;
        }
        if (this.addToCartBtn && this.addToCartText) {
          this.addToCartBtn.disabled = true;
          this.addToCartText.textContent = window.variantStrings?.unavailable || 'Unavailable';
        }
      }

      buildPriceHtml(variant) {
        const compareAt = variant.compare_at_price;

        if (compareAt && compareAt > variant.price && variant.compare_at_price_formatted) {
          return `
            <p class="product-grid-atc__item-price-discounted">${variant.price_formatted}</p>
            <p class="product-grid-atc__item-price-original">${variant.compare_at_price_formatted}</p>
            <p class="product-grid-atc__item-price-sale">Sale</p>
          `;
        }

        return `<p class="product-grid-atc__item-price-discounted">${variant.price_formatted}</p>`;
      }
    }
  );
}
